import { LitePanel } from './components/LitePanel'
import { SecondScreen } from './components/SecondScreen'
import { RecorderPage } from './components/RecorderPage'
import { CallRecordingProvider } from './contexts/CallRecordingContext'

function App() {
  // Simple path-based routing
  const path = window.location.pathname
  const params = new URLSearchParams(window.location.search)

  // /recorder route - minimal popup for iframe recording
  if (path === '/recorder' || params.get('mode') === 'recorder') {
    return (
      <CallRecordingProvider>
        <RecorderPage />
      </CallRecordingProvider>
    )
  }

  // /second-screen or /2nd-screen routes to SecondScreen
  if (path === '/second-screen' || path === '/2nd-screen') {
    return (
      <CallRecordingProvider>
        <SecondScreen />
      </CallRecordingProvider>
    )
  }

  // Default: LitePanel (main view)
  return (
    <CallRecordingProvider>
      <div className="lite-container">
        <LitePanel />
      </div>
    </CallRecordingProvider>
  )
}

export default App
